import * as React from 'react'
import { useMemo } from 'react'
import { EditableCustomField } from '@user/components/CustomFields'
import type { CustomField } from '@sales-center/common'
import type { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import { useTheme } from '@mui/material/styles'

type Props = {
  field: CustomField
  hideOptional?: boolean
  customSettings: ICustomFieldFormSetting[]
}

export function CustomFieldListItem(props: Props) {
  const { field, hideOptional, customSettings } = props

  const fieldSetting = useMemo(
    () => customSettings.find((x) => x.customFieldId === field.id),
    [customSettings, field.id],
  )
  const theme = useTheme()
  return (
    <>
      <EditableCustomField
        whiteBackground={true}
        field={field}
        hideOptional={hideOptional}
        margin="normal"
        fieldSetting={fieldSetting}
        textFieldProps={{ sx: { backgroundColor: theme.palette.common.white } }}
      />
    </>
  )
}
